import React from 'react';
import { connect } from 'react-redux';

import Permissions from '../../utils/constants/Permissions';

import { isAnyOfFirstInSecond } from '../../utils/helpers/general';

const {
  CAN_CREATE_PAYMENTS,
  CAN_CREATE_PROMISSORY_NOTE,
  CAN_EDIT_LOAN_APPLICATION,
  CAN_CREATE_CONTRACT,
  CAN_EDIT_RATING,
  CAN_APPLY_DISCOUNT,
  CAN_READ_LOAN_APPLICATION_NOTES,
  CAN_CREATE_LOAN_APPLICATION_NOTE,
  CAN_ARCHIVE_LOAN_APPLICATION,
  CAN_CREATE_PERMISSIONS,
  CAN_READ_PERMISSIONS,
  CAN_GRANT_PERMISSIONS,
  CAN_REVOKE_PERMISSIONS,
  CAN_CREATE_LOANS,
  CAN_UPDATE_BANK_ACCOUNT_BALANCE,
  CAN_READ_KYC_AND_AML,
  CAN_READ_BUTTON_CIEC_FORM,
} = Permissions;

/**
 * Renders children component if user permissions match any of allowed permissions.
 * @param {Array} allowedPermissions Allowed permissions array.
 */
const withAuthorize = allowedPermissions => {
  class Authorize extends React.Component {
    render() {
      const { userPermissions, children } = this.props;
      if (isAnyOfFirstInSecond(allowedPermissions, userPermissions))
        return children;
      return false;
    }
  }
  const mapStateToProps = state => {
    const { permissions } = state.user;
    return {
      userPermissions: permissions,
    };
  };
  return connect(mapStateToProps)(Authorize);
};

export const CanCreatePayment = withAuthorize([CAN_CREATE_PAYMENTS.value]);
export const CanCreatePromissoryNote = withAuthorize([
  CAN_CREATE_PROMISSORY_NOTE.value,
]);
export const CanCreateContract = withAuthorize([CAN_CREATE_CONTRACT.value]);
export const CanEditLoanApplication = withAuthorize([
  CAN_EDIT_LOAN_APPLICATION.value,
]);
export const CanEditRating = withAuthorize([CAN_EDIT_RATING.value]);
export const CanApplyDiscount = withAuthorize([CAN_APPLY_DISCOUNT.value]);
export const CanReadLoanApplicationNotes = withAuthorize([
  CAN_READ_LOAN_APPLICATION_NOTES.value,
]);
export const CanReadButton = withAuthorize([CAN_READ_BUTTON_CIEC_FORM.value]);
export const CanCreateLoanApplicationNote = withAuthorize([
  CAN_CREATE_LOAN_APPLICATION_NOTE.value,
]);
export const CanArchiveApplicationNote = withAuthorize([
  CAN_ARCHIVE_LOAN_APPLICATION.value,
]);
export const CanCreatePermissions = withAuthorize([
  CAN_CREATE_PERMISSIONS.value,
]);
export const CanReadPermissions = withAuthorize([CAN_READ_PERMISSIONS.value]);
export const CanGrantOrRevokePermissions = withAuthorize([
  CAN_GRANT_PERMISSIONS.value,
  CAN_REVOKE_PERMISSIONS.value,
]);
export const CanCreateContractOrPromissoryNote = withAuthorize([
  CAN_CREATE_CONTRACT.value,
  CAN_CREATE_PROMISSORY_NOTE.value,
]);
export const CanCreateLoan = withAuthorize([CAN_CREATE_LOANS.value]);
export const CanUpdateBankAccountBalance = withAuthorize([
  CAN_UPDATE_BANK_ACCOUNT_BALANCE.value,
]);
export const CanReadKycAml = withAuthorize([CAN_READ_KYC_AND_AML.value]);



// WEBPACK FOOTER //
// ./src/components/HOC/Authorize.js